<template>
  <main class="home">
    <div class="header-container">
      <Header
        navbarType="staticIcon"
        :screenTitle="screenTitle"
        :staticIcon="icon"
      />
    </div>
    <div
      class="pb-0 mt-1 position-absolute overflow-hidden w-100"
      style="top: 95px"
    >
      <div class="container fs-5 px-3">
        <b>{{ t("CREDIT_LINE_FEEDBACK.HELP_US") }}</b>
      </div>
      <PostUnlinkSurvey
        v-if="surveyType === 'BANK_ACCOUNT_UNLINK'"
        class="step-component"
        @next="handleNext"
      />
    </div>
  </main>
</template>

<script lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import Header from "@/shared-components/consumer/Header.vue";
import PostUnlinkSurvey from "@/apps/credit-line/components/Withdrawal/PostUnlinkSurvey.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";

export default defineComponent({
  name: "CreditLineSurveyView",
  components: {
    Header,
    PostUnlinkSurvey,
  },
  beforeMount() {
    setLanguage(this);
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const screenTitle = ref<string>("");
    const icon = ref<string>("");
    const surveyType = useRoute()?.query?.surveyType as string;

    if (surveyType === "BANK_ACCOUNT_UNLINK") {
      screenTitle.value = t("CREDIT_LINE_FEEDBACK.UNLINK_BANK_ACCOUNT_TITLE");
      icon.value = useAsset("img/credit-line/check-mark-icon.png");
    }

    const handleNext = () => {
      router.push({
        name: "UnlinkBankAccountSurveyResultView",
      });
    };

    return {
      router,
      surveyType,
      icon,
      screenTitle,
      useAsset,
      handleNext,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

$header-height: 85px;
.step-component {
  height: 100%;
  overflow-y: hidden;
  position: relative !important;
}

.header-container {
  height: $header-height;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $pj-color-green;
  font-size: 40px;
  background-color: rgba(150, 150, 150, 0.4);
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}
</style>
